import { colors } from 'ui/theme/colors';
import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { Add16 } from 'ui/icons/action/Add16';
import { StyledCircleIconBackground } from 'modules/ai/copyAssist/components/dropdown/styles';

export type CopyAssistDropdownItemIconProps = {
  isHovered: boolean;
  isSelected: boolean;
};
export const CopyAssistDropdownItemIcon = ({
  isHovered,
  isSelected,
}: CopyAssistDropdownItemIconProps) => {
  let icon;
  let bgColor;

  if (isHovered && !isSelected) {
    bgColor = 'grey';
    icon = <Add16 data-test="menu-list-add-icon" color={colors.textSecondary} />;
  } else if (isSelected) {
    bgColor = 'green';
    icon = <PositiveFill data-test="menu-list-checked-icon" color={colors.green100} />;
  } else {
    icon = <AiSparkle16 data-test="menu-list-copy-assist-sparkle" />;
  }
  return <StyledCircleIconBackground data-bg-color={bgColor}>{icon}</StyledCircleIconBackground>;
};
